import CryptoJS from 'crypto-js';

// Use a strong secret key from your .env or a secure variable
const SECRET_KEY = 'dialogix'; 

export const encryptData = (data) => {
  try {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    return ciphertext;
  } catch (error) {
    console.error("Encryption failed", error);
    return null;
  }
};

export const decryptData = (ciphertext) => {
  try {
    if (!ciphertext) return null;
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    console.error("Decryption failed", error);
    return null;
  }
};



export const getStoredUser = () => {
  const cipherText = localStorage.getItem('user');
  const user = decryptData(cipherText);
  return user; 
};